export enum Title {
    'Mr.',
    'Mrs.',
    'Ms.',
}
